var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { ThemeEvents, VariantUpdateEvent } from "@theme/events";
import { morph } from "@theme/morph";
import { Component } from "@theme/component";
class ProductInventory extends Component {
  constructor() {
    super(...arguments);
    /**
     * Updates the inventory.
     * @param {VariantUpdateEvent} event - The variant update event.
     */
    __publicField(this, "updateInventory", (event) => {
      if (event.detail.data.newProduct) {
        this.dataset.productId = event.detail.data.newProduct.id;
      } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
        return;
      }
      const newInventory = event.detail.data.html.querySelector("product-inventory");
      if (!newInventory) return;
      morph(this, newInventory, { childrenOnly: true });
    });
  }
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }
}
if (!customElements.get("product-inventory")) {
  customElements.define("product-inventory", ProductInventory);
}
